import React from "react";
import { Container } from "react-bootstrap";
import styles from "./ModernLayout.module.css";
import ModernHeader from "./ModernHeader";
import { NavActiveSectionProvider } from "./NavActiveSectionContext";

/**
 * ModernLayout - Base layout component for the Modern Interface
 * Provides consistent header, footer, and content structure across modern views
 */
const ModernLayout = ({ children, user, wideContent = false }) => {
  // Apply conditional container class based on content width needs
  const containerClass = wideContent
    ? `${styles.contentContainer} ${styles.contentContainerWide}`
    : `${styles.contentContainer} ${styles.contentContainerDefault}`;

  return (
    // NavActiveSectionProvider wraps BOTH the header (consumer) and the route
    // children (publisher) so a detail page can tell the nav which section to
    // highlight on routes that match neither NavLink.
    <NavActiveSectionProvider>
      <div className={styles.layoutWrapper}>
        {/* Header */}
        <ModernHeader user={user} />

        {/* Main Content Area */}
        <main className={styles.mainContent}>
          <Container fluid className={containerClass}>
            {children}
          </Container>
        </main>

        {/* Footer */}
        <footer className={styles.footer}>
          <Container fluid>
            <div className={styles.footerContent}>
              <span className={styles.footerText}>problems.coxautoinc.com</span>
            </div>
          </Container>
        </footer>
      </div>
    </NavActiveSectionProvider>
  );
};

export default ModernLayout;
